export default __webpack_public_path__ + "static/media/Tutorial-Step-2.2.6244e046.jpg";